import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=4dac935e"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingGeneral.vue?vue&type=style&index=0&id=4dac935e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports